module.exports = __webpack_public_path__ + "img/app.ae990080.jpeg";